import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "spinner"]

  connect() {
    this.element.addEventListener("click", () => this.press())
    this.element.closest("form")?.addEventListener("submit", () => this.submit())
  }

  press() {
    this.element.classList.add("p2p-submit-btn--pressed")
    setTimeout(() => this.element.classList.remove("p2p-submit-btn--pressed"), 200)
  }

  submit() {
    this.element.disabled = true
    if (this.hasLabelTarget) this.labelTarget.classList.add("hidden")
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
    this.spinnerTarget?.classList.add("flex")
  }
}
